"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeviewCheckBox = void 0;
var keycode = require("keycode");
var React = require("react");
var _Core_1 = require("../../../../_Core");
var Highlighted_1 = require("../../../../Highlighted");
var Icon_1 = require("../../../../Icons/Icon");
var TreeviewCheckBox_style_1 = require("./TreeviewCheckBox.style");
var TreeviewCheckBox = function (_a) {
    var Data = _a.Data, OnClickElement = _a.OnClickElement, HighlightedString = _a.HighlightedString;
    var divClickHandler = function (e) {
        e.stopPropagation();
        OnClickElement(Data);
    };
    var resetTabIndex = function (e) {
        var target = e.target;
        var rootUl = target.closest("ul[role='tree']");
        if (rootUl) {
            var htmlElements = rootUl.querySelectorAll("span[role='checkbox'][tabIndex='-1'], li[role='treeitem'][tabIndex='-1']");
            htmlElements.forEach(function (o) {
                o.tabIndex = 0;
            });
        }
    };
    var handleKeyboardEvent = function (e) {
        if (_Core_1.IsSpace(e)) {
            e.stopPropagation();
            OnClickElement(Data);
        }
        else if (keycode.isEventKey(e.nativeEvent, keycode.codes.tab)) {
            resetTabIndex(e);
        }
    };
    var getAriaChecked = function () { return Data.IsSelected ? "true" : Data.HasSelectedChildren ? "mixed" : "false"; };
    var getAriaLabelledBy = function () { return Data.UniqueID + "-tv-checkbox-label"; };
    return (React.createElement(TreeviewCheckBox_style_1.TreeviewWrapperSpan, null,
        React.createElement(TreeviewCheckBox_style_1.TreeviewSpan, { role: "checkbox", id: Data.UniqueID, tabIndex: 0, onClick: divClickHandler, onKeyDown: handleKeyboardEvent, "aria-checked": getAriaChecked(), "aria-labelledby": getAriaLabelledBy(), HasSelectedChildren: Data.HasSelectedChildren, IsSelected: Data.IsSelected },
            React.createElement(TreeviewCheckBox_style_1.TreeviewIconSpan, { Show: Data.IsSelected },
                React.createElement(Icon_1.Icon, { Icon: _Core_1.Icons.TickCircle }))),
        React.createElement(TreeviewCheckBox_style_1.CheckboxLabel, { id: getAriaLabelledBy(), onClick: divClickHandler },
            React.createElement(Highlighted_1.Highlighted, { Text: Data.Caption ? Data.Caption : "", Highlight: HighlightedString }))));
};
exports.TreeviewCheckBox = TreeviewCheckBox;
